import { Link } from "react-router-dom";
import { OvalLoader } from "../../../components/common/Loader";

const initialsOf = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const InsightCard = ({
  title,
  data,
  loading,
  emptyTitle,
  emptyDesc,
  linkTo,
  actionTitle,
  tone = "neutral",
}) => {
  const people = data || [];
  const hasRows = people.length > 0;
  const noun = people.length === 1 ? "member" : "members";
  const countLabel =
    tone === "absent"
      ? `${people.length} ${noun} absent`
      : `${people.length} ${noun} pending`;

  return (
    <div className={`insight-mini insight-mini--${tone}`}>
      {loading ? (
        <div className="insight-mini-loading">
          <OvalLoader color="#1E3A93" />
        </div>
      ) : (
        <>
          <div className="insight-mini-main">
            {tone === "fees" && !hasRows && (
              <span className="insight-mini-icon is-green">
                <i className="bx bx-check" aria-hidden="true"></i>
              </span>
            )}
            <div className="insight-mini-copy">
              <div className="insight-mini-kicker">{title}</div>
              <div className="insight-mini-title">
                {hasRows ? countLabel : emptyTitle}
              </div>
              {!hasRows && emptyDesc ? (
                <div className="insight-mini-desc">{emptyDesc}</div>
              ) : null}
            </div>
            {hasRows && (
              <div className="insight-mini-avatars">
                {people.slice(0, 3).map((user, i) => (
                  <span
                    key={i}
                    className="insight-mini-avatar"
                    title={user?.name || "Member"}
                  >
                    {initialsOf(user?.name)}
                  </span>
                ))}
                {people.length > 3 && (
                  <span className="insight-mini-more">+{people.length - 3}</span>
                )}
              </div>
            )}
          </div>
          {hasRows && (
            <Link to={linkTo} className="insight-mini-btn">
              {actionTitle}
            </Link>
          )}
        </>
      )}
    </div>
  );
};

const PendingListsTables = ({ data, loading, hasPermission }) => {
  return (
    <>
      {hasPermission("dashboard-monthly-fees-pending-list-view") && (
        <InsightCard
          title="Pending monthly fees"
          data={data?.monthlyFeesPendingList}
          loading={loading}
          emptyTitle="All fees collected"
          emptyDesc="No pending payments this month."
          linkTo="/reports/fees"
          tone="fees"
          actionTitle="Review payments"
        />
      )}
      {hasPermission("dashboard-weekly-meeting-not-attended-list-view") && (
        <InsightCard
          title="Meeting absentees"
          data={data?.weeklyMeetingPendingList}
          loading={loading}
          emptyTitle="All members present"
          emptyDesc="Excellent attendance this week."
          linkTo="/reports/attendance"
          tone="absent"
          actionTitle="Review attendance"
        />
      )}
    </>
  );
};

export default PendingListsTables;
